module.exports = __webpack_public_path__ + "static/media/pieDetail.44800656.png";